import { defaultTransformFn, dsApi } from "./DsApi";
import { Product } from "../entities/Product";
import { ProductGroup } from "../entities/ProductGroup";

const productsTags = dsApi.enhanceEndpoints({
  addTagTypes: ["Products", "ProductGroups", "Product"],
});

const productsApi = productsTags.injectEndpoints({
  endpoints: (build) => ({
    getProducts: build.query<Product[], void>({
      query: () => {
        return {
          url: `products`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "Products" }],
    }),
    getProductGroups: build.query<ProductGroup[], void>({
      query: () => {
        return {
          url: `products/groups`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "ProductGroups" }],
    }),
    getProduct: build.query<Product, { productId: string }>({
      query: ({ productId }) => {
        return {
          url: `products/${productId}`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "Product" }],
    }),
    updateProduct: build.mutation<Product, { product: Product }>({
      query: ({ product }) => {
        return {
          url: `products/${product.id}`,
          method: "PUT",
          data: {
            name: product.name,
            description: product.description,
            pricePerMonth: product.pricePerMonth,
            maxDiscount: product.maxDiscount,
            netCommissionableRevenue: product.netCommissionableRevenue,
            setupFee: product.setupFee,
          },
        };
      },
      transformResponse: defaultTransformFn,
      invalidatesTags: [{ type: "Product" }, { type: "ProductGroups" }],
    }),
    updateProductGroup: build.mutation<
      ProductGroup,
      { productGroup: ProductGroup }
    >({
      query: ({ productGroup }) => {
        return {
          url: `products/groups/${productGroup.id}`,
          method: "PUT",
          data: {
            name: productGroup.name,
            description: productGroup.description,
            isFlagshipProgram: productGroup.isFlagshipProgram,
            clientFacingProductGroupServices:
              productGroup.clientFacingProductGroupServices,
            pricePerMonth: productGroup.pricePerMonth,
            netCommissionableRevenue: productGroup.netCommissionableRevenue,
            setupFee: productGroup.setupFee,
          },
        };
      },
      transformResponse: defaultTransformFn,
      invalidatesTags: [{ type: "ProductGroups" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProductQuery,
  useGetProductsQuery,
  useGetProductGroupsQuery,
  useUpdateProductMutation,
  useUpdateProductGroupMutation,
} = productsApi;
